/**
 * Class representation of a user
 * 
 * @author Joshua Kissoon
 * @since 20170709
 */
export class User {
    id: number;
    name: string;
    email: string;
    password: string;
    enabled: string;
    client_id: number;
    user_type_id: number;
    is_temporary_password:boolean;
    type_id: number;

    roles: any;
    permissions: any;
    client: any;
    type: any;

    constructor() {
        this.id = 0;
    }

    loadFromMap(data: any) {
        this.id = data.id;
        this.email = data.email;
        this.name = data.name;
        this.enabled = data.enabled;
        this.client_id = data.client_id;
        this.user_type_id = data.user_type_id;
        this.is_temporary_password = data.is_temporary_password;
        this.type_id = data.type_id;

        this.roles = (data.roles == null) ? [] : data.roles;
        this.permissions = (data.permissions == null) ? [] : data.permissions;
        this.client = data.client;
        this.type = (data.type == null) ? [] : data.type;
    }

    hasRole(id: number) {
        if (this.roles == null) {
            return false;
        }

        for (var role of this.roles) {
            if (role.id == id) {
                return true;
            }
        }

        return false;
    }

    hasPermission(slug: string) {
        if (this.permissions == null) {
            return false;
        }

        for (var permission of this.permissions) {
            if (permission.slug == slug) {
                return true;
            }
        }

        return false;
    }


}